import { element } from 'protractor';
import { Blog } from './../model/blog';
import { Injectable } from '@angular/core';
import { Service } from './service.service';
import { HttpHeaders } from '../../../node_modules/@angular/common/http';

@Injectable()
export class BlogService extends Service<Blog> {


  protected getTable() {
    return 'blog';
  }

  ultimas() {
    return super.ultimas(2);
  }

  protected getPageMax() {
    return 5;
  }

  getConfig() {
    const configUrl = './../../assets/blog.json';
    return this.http.get(configUrl);
  }

  importar() {
    this.getConfig()
      .subscribe((data: any[]) => {
        data.forEach(elemento => {
          // console.log(element);
          if (elemento.foto) {
            this.http.get('./../../assets/destaque/' + elemento.foto, {responseType: 'blob'}).subscribe(foto => {
              this.upload(foto).then(upload => {
                elemento.foto = upload;
                this.salvar(elemento);
              });
            });
          } else {
            this.salvar(elemento);
          }
        });
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/service/blog.service.ts